"use client";
//#region packages/@mantine/core/src/components/AppShell/AppShellMediaStyles/get-base-size/get-base-size.ts
function getBaseSize(size) {
	if (typeof size === "object") return size.base;
	return size;
}
//#endregion
export { getBaseSize };

//# sourceMappingURL=get-base-size.mjs.map